import { render, staticRenderFns } from "./MenuPosizioni.vue?vue&type=template&id=ce5425ce&scoped=true&"
import script from "./MenuPosizioni.vue?vue&type=script&lang=js&"
export * from "./MenuPosizioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5425ce",
  null
  
)

export default component.exports